import script from "./DoughnutChartCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DoughnutChartCard.vue?vue&type=script&setup=true&lang=ts"

import "./DoughnutChartCard.vue?vue&type=style&index=0&id=15957b90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15957b90"]])

export default __exports__